import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { DigimatrixService } from '../../services/digimatrix.service';
import { LoginData } from '../../interfaces/login-data';
// import { Router } from '@angular/router';
import { LoginConfirm } from '../../interfaces/login-confirm';
import { Subscriber } from '../../interfaces/subscriber';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { SubscripeSharedDataService } from '../../services/subscripe-shared-data.service';
import { timer, map, take } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-anti-fraud',
  templateUrl: './anti-fraud.component.html',
  styleUrl: './anti-fraud.component.scss',
})
export class AntiFraudComponent implements OnInit, OnDestroy {

  otpValue: number | undefined
  otpValue1: number | undefined
  phoneMask: string | undefined
  availablePackages: any[] = []
  allPackages: any
  isSelectPackage: boolean = false
  subscriptionExpired: boolean = false
  selectedPackage: string | null = null;
  phoneNumber: string | undefined = ""
  transaction_identify!: string;
  loginForm: FormGroup = new FormGroup({});
  packageForm: FormGroup = new FormGroup({});
  unsubscribeForm: FormGroup = new FormGroup({});
  isLoginConfirm = false;
  subscripeSuccess: boolean = false
  isLogin = false;
  userDetails: Subscriber | null = null;
  error?: string;
  success?: string;
  successOTP?: string;
  errorOTP?: string;
  formType?: string = 'subscribe';
  isunsubscribe: boolean = false;
  subscribed: boolean = false;
  isUnsubscribeConfirm: boolean = false;
  currentPackage?: string;
  operator?: string;
  subscription_name?: string;
  isLoading: boolean = true;
  isSubmitting: boolean = false;
  isRouteNumber: boolean = false;
  phonePrefix: number | undefined
  is_user: boolean = true
  operatingSystem = localStorage.getItem('platform')
  countdownDisplay: string = "00:00"
  timerSubscription: Subscription = new Subscription()
  otpVisible: boolean = true
  @ViewChild('otpInput') otpInputRef!: ElementRef<HTMLInputElement>;
  isRedirectionPopupOpen: boolean = false

  constructor(
    private fb: FormBuilder,
    private digiMatrixService: DigimatrixService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private subscripeSharedDataService: SubscripeSharedDataService,
    private router: Router,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(9),
          Validators.maxLength(10),
          this.validatePhoneOtherNetwork,
          this.validatePhone
        ]
      ]
    });
    this.unsubscribeForm = this.fb.group({
      phone: [{ disabled: true, value: '' },
      [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(10),
        this.validatePhone
      ]
      ]
    });
    this.route.queryParams.subscribe((params) => {
      const routePhone = params['phone'];
      if (routePhone) {
        const phone = routePhone.toString().replace(/\D/g, '');
        const cleanedPhone = this.removePrefixFromNumber(phone.startsWith('218') ? phone.substring(3) : phone);
        this.phoneMask = String(cleanedPhone).replace(/.(?=..)/g, 'X')
        this.loginForm.get('phone')?.setValue(cleanedPhone);
        this.unsubscribeForm.get('phone')?.setValue(cleanedPhone);
        this.phoneNumber = phone;
        this.subscripeSharedDataService.setPhoneNumber(phone)
        this.isRouteNumber = true;

        if (phone) {
          this.subscriberDetails()
        }

      } else {
        this.isLoading = false;
      }

      const type = params['type'];
      if (type == 'unsubscribe') {
        this.formType = 'unsubscribe';
        this.isLogin = false;
        this.subscripeSharedDataService.setIsLogin(false)
        this.isunsubscribe = true;
      }

    })

    this.packageForm = this.fb.group({
      package: [null, Validators.required]
    });

    this.allPackages = {
      libyana: [
        {
          id: environment.libyanaDaily,
          nameAr: "ليبيانا اليومية",
          nameEn: "Daily libyana",
          price: "500",
          currency: "PRICE_CURRENCY2"
        },
        {
          id: environment.libyanaWeekly,
          nameAr: "ليبيانا الأسبوعية",
          nameEn: "Weekly libyana",
          price: "2.50",
          currency: "PRICE_CURRENCY"
        }
      ],
      elmadar: [
        {
          id: environment.madarWeekly,
          nameAr: "المدار الأسبوعية",
          nameEn: "Weekly Almadar",
          price: "2.50",
          currency: "PRICE_CURRENCY"
        }
      ]
    }

    this.subscripeSharedDataService.isSubscribed.subscribe(val => {
      this.subscribed = val
    })

    this.subscripeSharedDataService.isLogin.subscribe(val => {
      this.isLogin = val
    })

    this.subscripeSharedDataService.phoneNumber.subscribe(val => {
      this.phoneNumber = val
    })

    this.subscripeSharedDataService.subscriptionName.subscribe(val => {
      this.subscription_name = val
    })

  }

  ngOnDestroy(): void {
    if (!this.subscribed) {
      this.isLogin = true
      this.subscripeSharedDataService.setIsLogin(true)
      // this.subscripeSharedDataService.setPhoneNumber("")
      // this.subscripeSharedDataService
    }
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  redirectToApp() {
    const isIOS = this.operatingSystem === 'ios';
    const isAndroid = this.operatingSystem === 'android';

    const appUrl = isIOS
      ? 'hidayaLibyaApp://mobileApp'
      : 'hidayalibya://app';

    const storeUrl = isIOS
      ? 'https://apps.apple.com/eg/app/hidaya-libya/id6742405750?l=ar'
      : 'https://play.google.com/store/apps/details?id=com.hidayalibya&hl=en';

    let didHide = false;
    const onVisibilityChange = () => {
      if (document.hidden || document.visibilityState === 'hidden') {
        didHide = true;
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    window.location.href = appUrl;

    setTimeout(() => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (!didHide) {
        window.location.href = storeUrl;
      }
    }, 2500);
  }

  openRedirectionPopup() {
    if (this.operatingSystem === 'ios') {
      this.isRedirectionPopupOpen = true
    }
  }

  redirectToAppIOS() {
    const appUrl = 'hidayaLibyaApp://mobileApp'
    window.location.href = appUrl;
  }

  resendPassword() {
    this.digiMatrixService.resendPassword(this.phoneNumber!).subscribe(res => {
      if (res?.status == 'true') {
        this.timerSubscription.unsubscribe()
        const countdownSeconds = 2 * 60;

        timer(0, 1000)
          .pipe(
            take(countdownSeconds + 1),
            map((elapsedSeconds) => countdownSeconds - elapsedSeconds)
          )
          .subscribe((remainingSeconds) => {
            const minutes = Math.floor(remainingSeconds / 60);
            const seconds = remainingSeconds % 60;
            this.countdownDisplay = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
          });
      }
    })
  }

  /**
   * Called when the user presses the 'Subscripe' button.
   * This method will first check if the user has entered a phone number, if not it will show an error message.
   * If the phone number is valid, it will check if the user has already entered the phone number before.
   * If the user has entered the phone number before, it will show the list of packages to select from.
   * If the user has not entered the phone number before, it will call the subscriberDetails method to get the user's details.
   * If the user's details are retrieved successfully, it will show the list of packages to select from.
   */
  onLogin() {
    if (String(this.loginForm.get('phone')?.value).startsWith('91') || String(this.loginForm.get('phone')?.value).startsWith('091') || String(this.loginForm.get('phone')?.value).startsWith('92')
      || String(this.loginForm.get('phone')?.value).startsWith('092') || String(this.loginForm.get('phone')?.value).startsWith('93') || String(this.loginForm.get('phone')?.value).startsWith('093')
      || String(this.loginForm.get('phone')?.value).startsWith('94') || String(this.loginForm.get('phone')?.value).startsWith('094')) {
      const loginValues = this.loginForm;
      this.isSubmitting = true;
      const cleanedPhone = this.loginForm.get('phone')?.value.startsWith('218') ? this.loginForm.get('phone')?.value : '218' + this.loginForm.get('phone')?.value;

      if (cleanedPhone) {
        if (cleanedPhone && (this.phoneNumber == undefined || this.phoneNumber == '')) {
          this.isLoading = true;
          this.subscripeSharedDataService.setPhoneNumber(cleanedPhone)
          this.subscriberDetails();
        } else {
          this.subscripeSharedDataService.setIsLogin(false)
          this.isSelectPackage = true;
          this.error = '';

          localStorage.setItem('phone', cleanedPhone);

          this.checkPackages();
        }
      } else if (loginValues.invalid || (this.loginForm.get('phone')?.invalid && (this.loginForm.get('phone')?.dirty || this.loginForm.get('phone')?.touched))) {
        if (this.loginForm.get('phone')?.value == '') {
          this.error = this.translate.instant('PHONE_REQUIRED');
        } else {
          this.error = this.translate.instant('FORM_CHECK');
        }
      }
      this.isSubmitting = false;
    } else {
      this.error = this.translate.instant("SERVICE_NOT_AVAILABLE_MSG")
    }
  }

  /**
   * Called when the user presses the 'Subscripe' button.
   * This method will first check if the package is selected, if not it will show an error message.
   * If the package is selected, it will call the login method in the digiMatrixService to send an OTP to the user's phone number.
   * If the OTP is sent successfully, it will show a success message and open the OTP dialog.
   * If there is an error, it will show an error message.
   */
  onSubscripe(): void {
    this.isSubmitting = true;
    if (this.packageForm.get('package')?.value == null) {
      this.error = this.translate.instant('PACKAGE_REQUIRED');
    } else {
      this.error = '';
      const cleanedPhone = this.loginForm.get('phone')?.value.startsWith('218') ? this.loginForm.get('phone')?.value : '218' + this.loginForm.get('phone')?.value;
      const authObs: Observable<LoginData> = this.digiMatrixService.login(cleanedPhone, this.packageForm.get('package')?.value);

      authObs.subscribe(
        (resData) => {
          if (resData.status === 'false') {
            this.error = resData?.message;
          }
          if (resData.data.messageCode === '00') {
            this.phoneMask = String(this.loginForm.get('phone')?.value).replace(/.(?=..)/g, 'X')
            this.isLoginConfirm = true;
            this.renderer.setStyle(document.documentElement, 'overflow', 'hidden');
            setTimeout(() => {
              this.otpInputRef.nativeElement.focus();
            }, 300);
            const countdownSeconds = 2 * 60; // 2 minutes in seconds

            this.timerSubscription = timer(0, 1000)
              .pipe(
                take(countdownSeconds + 1),
                map((elapsedSeconds) => countdownSeconds - elapsedSeconds)
              )
              .subscribe((remainingSeconds) => {
                const minutes = Math.floor(remainingSeconds / 60);
                const seconds = remainingSeconds % 60;
                this.countdownDisplay = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
              });
            this.successOTP = this.translate.instant('OTP_SENT');
            this.error = '';
            this.isSubmitting = false;
          } else {
            this.error = this.translate.instant("ERROR");
          }
        },
        (errorMessage) => {
          this.error = this.translate.instant('ERROR');
        }
      );
    }

  }

  /**
   * send request to submit OTP 
   * if OTP is success then user is subscribed
   * if else show error message
   * 
   * @param NgForm authForm 
   */
  onLoginConfirm(authForm: NgForm) {
    this.isSubmitting = true;
    if (this.otpValue) {
      const cleanedPhone = this.loginForm.get('phone')?.value.startsWith('218') ? this.loginForm.get('phone')?.value : '218' + this.loginForm.get('phone')?.value;
      const authObs: Observable<LoginConfirm> = this.digiMatrixService.loginConfirm(this.otpValue!, cleanedPhone, this.packageForm.get('package')?.value);

      authObs.subscribe(
        (resData) => {
          if (resData.data.failed) {
            this.successOTP = '';
            this.isSubmitting = false;
            this.clearOtp()
            this.errorOTP = resData?.data?.failed?.message;
          } else if (resData.data.messageCode === '01') {
            this.successOTP = '';
            this.isSubmitting = false;
            this.clearOtp()
            this.errorOTP = this.translate.instant('OTP_INCORRECT');
          } else if (resData.data.error?.failed?.message) {
            this.successOTP = '';
            this.isSubmitting = false;
            this.clearOtp()
            this.errorOTP = this.translate.instant('OTP_INCORRECT');
          } else {
            this.subscripeSuccess = true
            this.openRedirectionPopup()
            this.subscripeSharedDataService.setIsLogin(false)
            this.subscripeSharedDataService.setIsSubscribed(true)
            this.isLoginConfirm = false;
            this.isSelectPackage = false;
            this.isSubmitting = false;
            this.errorOTP = '';
            let selectedPackage = this.availablePackages?.find((p: any) => p.id == this.packageForm.get('package')?.value)
            this.subscription_name = this.translate.currentLang == 'en' ? selectedPackage?.nameE! : selectedPackage?.nameAr;
            this.subscripeSharedDataService.setSubscriptionName(this.subscription_name || "")
            const countdownSeconds = 2 * 60; // 2 minutes in seconds

            this.timerSubscription = timer(0, 1000)
              .pipe(
                take(countdownSeconds + 1),
                map((elapsedSeconds) => countdownSeconds - elapsedSeconds)
              )
              .subscribe((remainingSeconds) => {
                const minutes = Math.floor(remainingSeconds / 60);
                const seconds = remainingSeconds % 60;
                this.countdownDisplay = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
              });

            if (this.operatingSystem === 'android') {
              this.redirectToApp()
            }

          }
        },
        (errorMessage) => {
          this.isSubmitting = false;
          this.clearOtp()
          this.error = this.translate.instant("ERROR");
        }
      );

    } else {
      this.errorOTP = this.translate.instant('OTP_REQUIRED');
      this.clearOtp()
    }

  }

  /**
   * Handles the unsubscribe form submission.
   * If the form is invalid, it shows an error message.
   * If the form is valid, it sends a request to the server to unsubscribe the user and handles the response.
   * If the response is successful, it shows a success message and sets isUnsubscribeConfirm to true.
   * If an error occurs, it shows an error message.
   */
  onUnsubscribe() {
    this.isSubmitting = true;

    if (this.unsubscribeForm.invalid || (this.unsubscribeForm.get('phone')?.invalid && (this.unsubscribeForm.get('phone')?.dirty || this.unsubscribeForm.get('phone')?.touched))) {
      if (this.unsubscribeForm.get('phone')?.value == '') {
        this.error = this.translate.instant('PHONE_REQUIRED');
      } else {
        this.error = this.translate.instant('FORM_CHECK');
      }
    } else {
      const cleanedPhone = this.unsubscribeForm.get('phone')?.value.startsWith('218') ? this.unsubscribeForm.get('phone')?.value : '218' + this.unsubscribeForm.get('phone')?.value;
      this.digiMatrixService.unsubscribe(cleanedPhone).subscribe(
        (resData) => {
          if (resData.data.failed) {
            this.error = resData?.data?.failed?.message;
          } else {
            this.successOTP = this.translate.instant('OTP_SENT');
            this.phoneMask = String(this.unsubscribeForm.get('phone')?.value).replace(/.(?=..)/g, 'X')
            this.isUnsubscribeConfirm = true;
            this.renderer.setStyle(document.documentElement, 'overflow', 'hidden');
            this.isSubmitting = false;
            const countdownSeconds = 2 * 60; // 2 minutes in seconds

            this.timerSubscription = timer(0, 1000)
              .pipe(
                take(countdownSeconds + 1),
                map((elapsedSeconds) => countdownSeconds - elapsedSeconds)
              )
              .subscribe((remainingSeconds) => {
                const minutes = Math.floor(remainingSeconds / 60);
                const seconds = remainingSeconds % 60;
                this.countdownDisplay = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
              });
          }
        },
        (errorMessage) => {
          this.error = this.translate.instant("ERROR");
        });
    }

  }

  /**
   * Sends an unsubscribe confirmation request to the server and handles the response.
   * If the OTP is correct, it shows a success message and resets the unsubscribe form.
   * If the OTP is incorrect, it shows an error message.
   * If an error occurs, it shows an error message.
   */
  onUnsubscribeConfirm() {
    this.isSubmitting = true;

    if (this.otpValue) {
      if (typeof this.otpValue !== 'number') {
        this.clearOtp()
        this.isSubmitting = false;
        this.errorOTP = this.translate.instant('OTP_NUMBER');
      } else {
        const cleanedPhone = this.unsubscribeForm.get('phone')?.value.startsWith('218') ? this.unsubscribeForm.get('phone')?.value : '218' + this.unsubscribeForm.get('phone')?.value;
        const authObs: Observable<LoginConfirm> = this.digiMatrixService.unsubscribeConfirm(this.otpValue!, cleanedPhone);
        authObs.subscribe(
          (resData) => {
            if (resData.data.failed) {
              this.successOTP = '';
              this.errorOTP = resData?.data?.failed?.message;
              this.isSubmitting = false;
              this.clearOtp()
            } else if (resData.data.error?.failed?.message) {
              this.successOTP = '';
              this.errorOTP = this.translate.instant('OTP_INCORRECT');
              this.isSubmitting = false;
              this.clearOtp()
            } else {
              this.subscripeSharedDataService.setIsLogin(true)
              this.isLoginConfirm = false;
              this.isSelectPackage = false;
              this.isUnsubscribeConfirm = false;
              this.isunsubscribe = false;
              this.confirmationService.confirm({
                key: 'confirm',
                rejectVisible: true,
                message: this.translate.instant('UNSUBSCRIPE_SUCCESS'),
              });
              this.errorOTP = '';
              this.isSubmitting = false;

              // this.digiMatrixService.logoutUserOnUnsubscribe(this.unsubscribeForm.get('phone')?.value).subscribe(
              //   (resData) => {
              //     console.log('Logout Response:', resData);
              //   },
              //   (error) => {
              //     console.error('Logout Error:', error);
              //   }
              // );
            }
          },
          (errorMessage) => {
            this.isSubmitting = false;
            this.error = this.translate.instant("ERROR");
          }
        );
      }
    } else {
      this.errorOTP = this.translate.instant('OTP_REQUIRED');
    }

  }

  /**
   * check for user subscription status 
   * if cancelled then show packages to re-subscribe
   * else show subscription details 
   * if expiration date is bigger than now then show already subscribed for that package
   * if else show subscription expired and show packages to re-subscribe 
   */
  subscriberDetails() {
    if (this.phoneNumber) {
      this.phoneNumber = this.phoneNumber.startsWith('2180') ? this.phoneNumber.replace('2180', '218') : this.phoneNumber;
      this.digiMatrixService.subscriberDetails(this.phoneNumber).subscribe(
        (resData) => {
          if (resData.data.error?.messageCode === '08') {
            this.checkPackages();
            this.subscripeSharedDataService.setIsLogin(false)
            this.isSelectPackage = true;
            this.isunsubscribe = false;
            this.isLoginConfirm = false;
            this.isUnsubscribeConfirm = false;
            this.is_user = resData.data?.is_user!

          } else if (resData.data.success?.details?.status == 'cancel') {
            this.checkPackages();
            this.isSelectPackage = true;
            this.subscripeSharedDataService.setIsLogin(false)
            this.isunsubscribe = false;
            this.isLoginConfirm = false;
            this.isUnsubscribeConfirm = false;
            this.subscripeSharedDataService.setIsSubscribed(false)
            this.is_user = resData.data?.is_user!
            this.subscription_name = resData?.data?.success?.details?.subscription_name;

            this.subscripeSharedDataService.setSubscriptionName(this.subscription_name || "")

          } else if (resData.data.error) {
            this.error = this.translate.instant('PHONE_PATTERN');
            this.isLogin = true;
            this.isunsubscribe = false;
            this.isLoginConfirm = false;
            this.isUnsubscribeConfirm = false;
            this.subscripeSharedDataService.setIsLogin(true)

          } else {
            const expiration_date = resData?.data?.success?.details?.expiration_date;
            this.subscription_name = resData?.data?.success?.details?.subscription_name;
            this.subscripeSharedDataService.setSubscriptionName(this.subscription_name || "")
            this.is_user = resData.data?.is_user!

            const date1 = formatDate(new Date(), 'yyyy-MM-dd HH:mm', 'en_US');
            const date2 = formatDate(expiration_date!, 'yyyy-MM-dd HH:mm', 'en_US');

            if (date2 > date1) {
              this.isLogin = false;
              this.subscripeSharedDataService.setIsLogin(false)
              this.isunsubscribe = false;
              this.isLoginConfirm = false;
              this.isUnsubscribeConfirm = false;
              this.subscripeSharedDataService.setIsSubscribed(true)

            } else {
              //this.error = `${this.translate.instant('EXPIRED_ACCOUNT1')} ${this.loginForm.get('phone')?.value} ${this.translate.instant('EXPIRED_ACCOUNT2')} ${resData.data.success?.details?.subscription_name} ${this.translate.instant('EXPIRED_ACCOUNT3')}`;
              this.subscripeSharedDataService.setIsSubscribed(false)

              if (!this.isRouteNumber) {
                this.isLogin = false;
                this.subscripeSharedDataService.setIsLogin(false)
                this.isSelectPackage = false;
                this.subscriptionExpired = true
                this.checkPackages();
              }

            }
          }
          this.userDetails = resData;

          this.isLoading = false;
        },
        (errorMessage) => {

        }
      );
    }

  }

  /**
   * check for packages regarding the phone number
   * if prefix is starting with 21891 or 21893 then it will show the elmadar packages
   * else it will show the libyana packages
   */
  checkPackages() {
    let phone = this.loginForm.get('phone')?.value.trim();

    // Remove leading 0 if present
    if (phone.startsWith('0')) {
      phone = phone.substring(1);
    }

    // Add '218' if not already present
    let cleanedPhone = phone.startsWith('218') ? phone : '218' + phone;

    // Remove leading 0 if it appears right after '218'
    if (cleanedPhone.startsWith('2180')) {
      cleanedPhone = '218' + cleanedPhone.substring(4);
    }

    const prefix = Math.floor(+cleanedPhone / 10000000); // Get the first 5 digits

    this.phonePrefix = prefix;
    if (prefix === 21891 || prefix === 21893) {
      this.availablePackages = this.allPackages.elmadar;
    } else {
      this.availablePackages = this.allPackages.libyana;
    }
  }

  /**
   * Hides the OTP dialog and resets the related flags.
   */
  hideOtpPopup() {
    this.isLoginConfirm = false;
    this.renderer.setStyle(document.documentElement, 'overflow', '');
    this.timerSubscription.unsubscribe()
    this.countdownDisplay = "00:00"
    this.clearOtp()
    this.errorOTP = '';
    this.successOTP = '';
  }

  hideRedirectionPopup() {
    this.isRedirectionPopupOpen = false
  }

  /**
   * Cancels the subscription process and resets the form.
   */
  onCancel() {
    this.subscripeSharedDataService.setIsSubscribed(false)
    this.isunsubscribe = true;
    const cleanedPhone = this.phoneNumber?.startsWith('218') ? this.phoneNumber?.substring(3) : this.phoneNumber;
    this.unsubscribeForm.get('phone')?.setValue(cleanedPhone);
  }

  /**
   * Ensures that only numeric characters are allowed in the input field.
   * 
   * @param event - The input event triggered by the user.
   * 
   * The function modifies the value of the input field by removing any 
   * non-numeric characters.
   */
  allowOnlyNumbers(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ''); // Remove any non-numeric characters
  }

  /**
   * A custom validator function that checks if the phone number matches the pattern:
   * - Starts with 9 (without 0) and followed by 8 digits
   * - Starts with 09 (with 0) and followed by 9 digits
   * 
   * @param c - The AbstractControl to validate.
   * 
   * @returns The validation result.
   */
  validatePhone(c: FormControl) {
    let FirstPattern = /^9(1|2|3|4)[0-9]{7}$/; // Regular Expression for numbers starting without 0
    let SecondPattern = /^09(1|2|3|4)[0-9]{7}$/; // Regular Expression for numbers starting with 0

    return (FirstPattern.test(c.value) || SecondPattern.test(c.value)) ? null : {
      validateInput: {
        valid: false
      }
    };
  }

  validatePhoneOtherNetwork(c: FormControl) {
    let FirstPattern = /^9(5|6|7|8|9)[0-9]{7}$/; // Regular Expression for numbers starting without 0
    let SecondPattern = /^09(5|6|7|8|9)[0-9]{7}$/; // Regular Expression for numbers starting with 0

    return (FirstPattern.test(c.value) || SecondPattern.test(c.value)) ? {
      validatePhoneOtherNetwork: {
        valid: true
      }
    } : null;
  }


  removePrefixFromNumber(phoneNumber: string) {
    if (phoneNumber.startsWith('0')) {
      return phoneNumber.substring(1);
    }

    return phoneNumber;
    // return phoneNumber.startsWith('218') ? phoneNumber.substring(3) : phoneNumber;
  }

  returnToMain() {
    this.subscripeSharedDataService.setIsLogin(true)
    this.subscriptionExpired = false
    this.phoneNumber = ""
    this.selectedPackage = ""
    this.loginForm.get('phone')?.setValue("")
  }

  onOtpChange(value: any) {
    if (/^\d+$/.test(value)) {
      this.otpValue = Number(value);
    } else {
      this.clearOtp()
    }
  }

  clearOtp() {
    this.otpValue = undefined

    this.otpVisible = false;
    setTimeout(() => {
      this.otpVisible = true;
    });
  }
}
